An array of additional address lines.

These may include an apartment or suite number.
